import templateUrl from "./404.component.html";
import "./error-page.less";

export const NotFoundComponent = {
    templateUrl
};
